import React, { ReactElement } from 'react';
import { ButtonProps } from 'react-bootstrap';
import { LinkProps } from 'react-router-dom';

export type ButtonSize = 'large' | 'medium' | 'small';

export type ButtonKind =
    | 'primary'
    | 'secondary'
    | 'ghost'
    | 'danger'
    | 'nostyles';

export interface SusyButtonBaseProps {
    text: string;
    icon?: ReactElement;
    onClickHandler?: (
        ev: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
    classes?: string;
    dataTestId?: string;
    htmlAttributes?: React.ButtonHTMLAttributes<HTMLButtonElement>;
    fullWidth?: boolean;
    kind?: ButtonKind;
    iconPosition?: 'start' | 'end';
    size?: ButtonSize;
    loading?: boolean;
    disabled?: boolean;
}

export interface SusyButtonProps extends SusyButtonBaseProps {
    innerRef?: React.Ref<HTMLButtonElement> | undefined;
}

export interface SusyLinkButtonProps extends SusyButtonBaseProps, LinkProps {
    anchorHtmlAttributes?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
    innerRef?: React.Ref<HTMLAnchorElement> | undefined;
}

export interface SusyButtonIconProps extends ButtonProps {
    icon: ReactElement;
    onClickHandler?: (
        ev: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
    classes?: string;
    dataTestId?: string;
    htmlAttributes?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

export const getButtonClassAccordingToSize = (buttonSize: ButtonSize) => {
    switch (buttonSize) {
        case 'small': {
            return 'susy-button-sm';
        }
        case 'medium': {
            return 'susy-button-md';
        }
        case 'large':
        default: {
            return 'susy-button-lg';
        }
    }
};

export const getButtonClassAccordingToKind = (buttonKind: ButtonKind) => {
    switch (buttonKind) {
        case 'secondary': {
            return 'susy-button-light';
        }
        case 'ghost': {
            return 'susy-button-ghost';
        }
        case 'danger': {
            return 'susy-button-danger';
        }
        case 'nostyles': {
            return 'susy-button-no-styles susy-button-no-style-text-color';
        }
        case 'primary':
        default: {
            return 'susy-button-primary';
        }
    }
};
